import api from "../api";

const url = "/shop";

export default {
  getBasketCount() {
    return api.get(`${url}/basket/count`);
  },
  getBasket(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/basket/` + query);
  },
  getShopItems(type, filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/publications/${type}/` + query);
  },
  getShopItemsBySearch(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/publications/search/` + query);
  },
  addToBasket(payload, publicationSlug) {
    return api.post(
      `${url}/publications/${publicationSlug}/addToBasket`,
      payload
    );
  },
  removeFromBasket(publicationSlug) {
    return api.delete(
      `${url}/publications/${publicationSlug}/removeFromBasket`
    );
  },
  addToWishList(payload, publicationId) {
    return api.post(`${url}/wishlist/${publicationId}/`, payload);
  },
  removeFromWishList(publicationId) {
    return api.delete(`${url}/wishlist/${publicationId}/`);
  },
  getWishList() {
    return api.get(`${url}/wishlist/`);
  },
  getInvoices(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/invoices/` + query);
  },
  getCustomerOrders(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/` + query);
  },
  getInvoiceDetail(invoiceId) {
    return api.get(`${url}/invoices/${invoiceId}/`);
  },
  getInvoiceDetailInLatestOrder(invoiceId) {
    return api.get(`${url}/latest-order-invoices/${invoiceId}/`);
  },
  getPublication(id) {
    return api.get(`${url}/publications/${id}/`);
  },
  getReceiverDetail(publicationSlug) {
    return api.get(`${url}/publications/${publicationSlug}/defineReceiver`);
  },
  updateReceiverDetail(publicationSlug, payload) {
    return api.patch(
      `${url}/publications/${publicationSlug}/defineReceiver`,
      payload
    );
  },
  getReview() {
    return api.get(`${url}/basket/preview/`);
  },
  confirm(payload) {
    return api.post(`${url}/basket/confirm/`, payload);
  },
  getClaims(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/claims/` + query);
  },
  getClaimsPublications() {
    return api.get(`${url}/claimsPublications/`);
  },
  exportClaimList(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/claims/exportXlsx` + query);
  },
  downloadClaimFile(fileName) {
    return api.get(`${url}/claims/downloadReport/${fileName}`, {
      responseType: "blob"
    });
  },
  createClaim(payload, payload_without_image, image) {
    if (image != null) {
      return api.post(`${url}/claims/`, payload, {
        mimeType: "multipart/form-data"
      });
    }
    else {
      return api.post(`${url}/claims/`, payload_without_image);
    }

  },
  getClaim(claimId) {
    return api.get(`${url}/claims/${claimId}`);
  },
  sendMessage(claimId, payload, payload_without_image, image) {
    if (image != null) {
      return api.post(`${url}/claims/${claimId}/messages/`, payload, {
        mimeType: "multipart/form-data"
      });
    } else {
      return api.post(`${url}/claims/${claimId}/messages/`, payload_without_image);
    }
  },
  confirmClaim(claimId, payload) {
    return api.post(`${url}/claims/${claimId}/confirm/`, payload);
  },
  cancelClaim(claimId, payload) {
    return api.post(`${url}/claims/${claimId}/cancel/`, payload);
  },
  renewItems(payload) {
    return api.post(`${url}/orders/renew`, payload);
  },
  cancelOrder(payload) {
    return api.post(`${url}/orders/cancel`, payload);
  },
  exportList(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/exportXlsx` + query);
  },
  downloadFile(fileName) {
    return api.get(`${url}/invoices/downloadReport/${fileName}`, {
      responseType: "blob"
    });
  },
  productRequest(payload) {
    return api.post(`${url}/orders/productRequests/`, payload);
  },
  clone(itemId) {
    return api.get(`${url}/basket/${itemId}/clone`);
  },
  nearRenewal(filter = "") {
    return api.get(`${url}/orders/getNearForRenewal${filter}`);
  },
  renewUsingEmail(payload) {
    return api.post(`${url}/orders/renewByToken`, payload);
  },
  exportInvoiceDetailPdf(invoiceId, payload) {
    return api.post(`${url}/invoices/${invoiceId}/exportPDF`, payload);
  },
  insights() {
    return api.get(`${url}/orders/insights/`);
  },
  superclientOrders(filter) {
    let query = "";
    if (filter) {
      query = filter;
    }
    return api.get(`${url}/orders/clientOrders` + query);
  },
  suggest(query) {
    return api.get(`${url}/publications/suggest/` + query);
  },
  retrieveByToken(payload) {
    return api.post(`${url}/claims/retrieveByToken`, payload);
  },
  retrieveByTokenChangeAddress(payload) {
    return api.post(`${url}/change-address-requests/retrieveByToken`, payload);
  },
  changeAddress(payload) {
    return api.post(`${url}/change-address-requests/`, payload);
  },
  check(orderId) {
    return api.get(`${url}/change-address-requests/${orderId}/has-request/`);
  },
  changeAddressRequests(filter) {
    let query = "";
    if (filter !== "?") {
      query = filter;
    }
    return api.get(`${url}/change-address-requests/` + query);
  },
  cancelChangeAddressReq(reqId, payload) {
    return api.post(`${url}/change-address-requests/${reqId}/cancel/`, payload);
  },
  getPreview(reqId) {
    return api.get(`${url}/change-address-requests/${reqId}/preview/`);
  },
  setCostCenter(payload) {
    return api.post(`${url}/orders/set-costcenter/`, payload);
  },
  chartData(filter) {
    let data = {};
    return api
      .get(`/statistic/orders/cost-center-pie-chart/` + filter)
      .then(response => {
        data.costCenterPieChart = response.data.results;
        return api.get(`/statistic/orders/publication-pie-chart/` + filter);
      })
      .then(response => {
        data.publicationPieChart = response.data.results;
        return api.get(`/statistic/orders/year-line-chart/` + filter);
      })
      .then(response => {
        data.yearLineChart = response.data.results;
        return api.get(`/statistic/orders/year-pie-chart/` + filter);
      })
      .then(response => {
        data.yearPieChart = response.data.results;
        return api.get(`/statistic/orders/paper-digital-pie-chart/` + filter);
      })
      .then(response => {
        data.paperDigitalPieChart = response.data;

        return api.get(`/statistic/orders/publishers/` + filter);
      })
      .then(response => {
        data.productByPublishersChart = response.data.results;
        return data;
      });
  },
  getPublicationItems() {
    return api.get(`${url}/orders/myPublications/`);
  },
  exportStatisticsXlsx(filter) {
    let query = "";
    if (filter !== "?") {
      query = filter;
    }
    return api.get(`${url}/orders/exportStatisticsXlsx` + query);
  },
  getHoldOrders(params = {}) {
    return api.get('shop/hold-orders', { params });
  },
  createHold(payload) {
    return api.post(`${url}/hold-orders`, payload);
  },
  cancelHold(cancelParam) {
    let HoldId = cancelParam.id
    delete cancelParam.id
    return api.post(`${url}/hold-orders/${HoldId}/cancel`, cancelParam);
  },
};
